import { render } from "./Leaders.vue?vue&type=template&id=a2ff6c22"
import script from "./Leaders.vue?vue&type=script&lang=js"
export * from "./Leaders.vue?vue&type=script&lang=js"
script.render = render

export default script